export default {
	type: 'object',
	properties: {
		mnemonicId: { type: 'string' },
	},
	required: ['mnemonicId'],
	additionalProperties: false,
}
